<script lang="ts">
  // Labels bar (spec §15): one chip per decoded `TIK_<hex>` flag with a remove button, plus
  // the `+ addLabel` button that opens the prompt in the parent.
  import { t } from '$lib/i18n';

  let {
    labels,
    onadd,
    onremove,
  }: {
    labels: readonly string[];
    onadd: () => void;
    onremove: (label: string) => void;
  } = $props();
</script>

<div class="labels" data-count={labels.length}>
  {#each labels as label (label)}
    <span class="lchip2"><bdi>{label}</bdi><button type="button" class="lx" aria-label="{t('del')}: {label}" onclick={() => onremove(label)}>×</button></span>
  {/each}
  <button type="button" class="ladd" onclick={onadd}>+ {t('addLabel')}</button>
</div>

<style>
  /* svelte-rwh28b (Reader) — labels */
  .labels {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--space-2);
    margin-top: var(--space-3)
  }

  .lchip2 {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px var(--space-2);
    border-radius: var(--radius-pill);
    background: var(--info-100, var(--surface-sunken));
    border: 1px solid var(--border-accent);
    color: var(--text-link);
    font-size: var(--text-xs)
  }

  .lx {
    border: 0;
    background: none;
    color: inherit;
    cursor: pointer;
    font-size: var(--text-sm);
    line-height: 1;
    padding: 0 2px
  }

  .ladd {
    border: 1px dashed var(--border-default);
    border-radius: var(--radius-pill);
    background: none;
    color: var(--text-muted);
    padding: 2px var(--space-3);
    font-size: var(--text-xs);
    cursor: pointer
  }
</style>
